export default __webpack_public_path__ + "static/media/slide24.eeeeceac.png";